import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import './style.scss';
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
const eventIcon = {
	src: (
		<svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
			width="800px" height="800px" viewBox="0 0 253 260" enable-background="new 0 0 253 260">
			<path d="M194.221,2c-5.959,0-10.814,4.855-10.814,10.814V46.8c0,5.959,4.855,10.814,10.814,10.814s10.814-4.855,10.814-10.814
	V12.814C205.035,6.855,200.179,2,194.221,2 M250.938,33.338v57.159V258H2V90.276V33.338h33.766v13.683
	c0,12.579,10.152,22.952,22.952,22.952C71.297,69.972,81.669,59.6,81.669,47.021V33.338h89.6v13.683
	c0,12.579,10.372,22.952,22.952,22.952c12.579,0,22.952-10.372,22.952-22.952V33.338H250.938z M237.476,90.497H15.462v153.6h172.579
	l49.434-48.772V90.497H237.476z M58.717,2c-5.958,0-10.814,4.855-10.814,10.814V46.8c0,5.959,4.855,10.814,10.814,10.814
	c5.959,0,10.814-4.855,10.814-10.814V12.814C69.531,6.855,64.676,2,58.717,2 M194.221,2c-5.959,0-10.814,4.855-10.814,10.814V46.8
	c0,5.959,4.855,10.814,10.814,10.814s10.814-4.855,10.814-10.814V12.814C205.035,6.855,200.179,2,194.221,2 M114.175,222.938
	l-53.158-53.159l21.213-21.213l31.976,31.976l59.594-59.423l21.184,21.244L114.175,222.938z"/>
		</svg>
	),
	background: 'var(--wp--preset--color--white)',
	foreground: 'var(--wp--preset--color--black)',
};
registerBlockType(metadata.name, {
	icon: eventIcon,
	edit: Edit,
	save: Save,
});
